<template>
  <div style="margin-bottom:50px;">
    <Title
      :pages="[{ icon: 'truck-moving', page: page_title.toUpperCase() }]"
    ></Title>

    <div
      style="padding:20px;margin-top:50px"
      v-if="list_access || create_access"
    >
      <v-tabs v-model="tab">
        <v-tab v-for="item in items" :key="item.key">
          {{ item.tab }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item
          @click="tab = 0"
          key="0"
          style="background:#f5f5f5"
          class="elevation-1"
        >
          <Vehiculos></Vehiculos>
        </v-tab-item>
        <v-tab-item
          @click="tab = 1"
          key="1"
          style="background:#f5f5f5"
          class="elevation-1"
        >
          <TipoVehiculo></TipoVehiculo>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
import Vehiculos from "./Vehiculos";
import TipoVehiculo from "./TipoVehiculo";
import Title from "@/components/Title.vue";
import RolMixin from "@/mixins/RolMixin.vue";
export default {
  components: {
    Title,
    Vehiculos,
    TipoVehiculo,
  },
  mixins: [RolMixin],
  data() {
    return {
      page_title: "Vehiculos",
      tab: 0,
      list: [],
      items: [
        { tab: this.$t("Vehiculos"), key: "0" },
        { tab: "Tipo de " + this.$t("Vehiculos"), key: "1" },
      ],
    };
  },
  mounted() {},
  methods: {},
};
</script>
